var membership_table = ( function ( $ ) {

	var $table,
		$tds,
		$controls,
		$cycle_switcher;

	var _init = function () {
		$table             = $( '.membership-options .membership-options-table' );
		$tds               = $table.find( '.cell.free, .cell.standard, .cell.premium, .cell.pro' );
		$controls          = $( '.membership-options .controls' );
		$cycle_switcher    = $controls.find( '.cycle-switcher' );

		_setup_cycle_switcher();

		$tds.on( 'click', _maybe_change_active );
	};

	var _setup_cycle_switcher = function() {
		$cycle_switcher.find( 'a' ).on( 'click', _switch_cycle );
	};

	var _switch_cycle = function( e ) {
		e.preventDefault();

		$cycle_switcher.find( 'a' ).removeClass( 'active' );
		$( this ).addClass( 'active' );

		var cycle = $( this ).data( 'cycle' );

		$tds.find( '.price' ).removeClass( 'shown' );
		$tds.find( '.price[data-cycle=' + cycle + ']' ).addClass( 'shown' );

		$tds.find( '.next-step' ).addClass( 'hidden' );
		$tds.find( '.next-step[data-cycle=' + cycle + ']' ).removeClass( 'hidden' );

		$tds.find( 'a[data-' + cycle + ']' ).each(function() {
			$(this).prop( 'href', $(this).data( cycle ) );
		});
	};

	var _maybe_change_active = function() {
		if ( $( this ).hasClass( 'active' ) ) {
			return;
		}

		if ( $( this ).hasClass( 'free' ) ) {
			_change_active( 'free' );
		}

		if ( $( this ).hasClass( 'standard' ) ) {
			_change_active( 'standard' );
		}

		if ( $( this ).hasClass( 'premium' ) ) {
			_change_active( 'premium' );
		}

		if ( $( this ).hasClass( 'pro' ) ) {
			_change_active( 'pro' );
		}

	};

	var _change_active = function( elem_class ) {
		$tds.removeClass( 'active' );

		$tds.each( function() {
			if ( $( this ).hasClass( elem_class ) ) {
				$( this ).addClass( 'active' );
			}
		})
	};

	if ( $( '.membership-options .membership-options-table' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = membership_table;